import React from "react";
import Card from "./card";

export default function PostCard({ className = "", post, isShort = false }) {
  let firstHeader = "";
  if (post.headings && post.headings[0]) {
    firstHeader = post.headings[0].value;
  }

  const excerpt = (post.excerpt || "").replace(firstHeader, "");

  return (
    <Card
      className={className}
      img={post.frontmatter?.banner}
      alt={post.frontmatter.title}
      to={post.fields.slug}
      imgHeightClass={isShort ? "h-32 lg:h-60" : undefined}
    >
      <h2 className="text-center uppercase text-primary">
        {post.frontmatter.title}
      </h2>
      {post.excerpt && <p className="text-center flex-grow pt-2">{excerpt}</p>}
    </Card>
  );
}
